import { QRCodeSVG } from "qrcode.react";

import { UiWarningIcon } from "@jti/brand-icons/ui-warning";
import { Loader } from "@jti/core-components/components/Loader";

import styles from "./QrCode.module.scss";

export type QrCodeProps = {
  qrCodeValue: string;
  isLoading: boolean;
  errorMessage: string;
};

export const QrCode: React.FC<QrCodeProps> = ({ errorMessage, isLoading, qrCodeValue }) => {
  return (
    <div className={styles.wrapper}>
      <QRCodeSVG value={qrCodeValue || ""} size={140} data-testid="QrCode" />

      {isLoading && (
        <div className={styles.overlay} data-testid="qrLoadingOverlay">
          <Loader data-testid="qrLoader" />
        </div>
      )}
      {errorMessage && !isLoading && (
        <div className={styles.overlay} data-testid="qrErrorOverlay">
          <UiWarningIcon className={styles.warningIcon} />

          {errorMessage && <span>{errorMessage}</span>}
        </div>
      )}
    </div>
  );
};
